import e from "../../../utilities/tw.js";
const r = {
  base: e`size-5 rounded-full border-2 border-primary hover:border-primary-hover focus-visible:outline-none`,
  disabled: e` data-[disabled]:border-disabled data-[disabled]:data-[state=unchecked]:bg-disabled-surface`,
  indicator: e`relative flex size-full items-center justify-center after:block after:size-2.5 after:rounded-[50%] after:content-[''] after:focus:bg-primary after:data-[state=checked]:bg-primary data-[disabled]:data-[state=checked]:after:bg-disabled after:data-[state=checked]:hover:bg-primary-hover data-[disabled]:data-[state=checked]:after:hover:bg-disabled`
};
export {
  r as radioItemStyles
};
